import React, {
  useRef,
  useState,
  useEffect
} from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";

export const AgregarCargo = (props) => {
  // Refs para todos los campos del formulario
  const txtCargo = useRef(null);
  const txtDepartamento = useRef(null);
  const txtFechaInicio = useRef(null);
  const txtFechaFin = useRef(null);
  const txtObservacion = useRef(null);

  // Estado para el modo de operación (1: nuevo, 2: editar, 4: consultar)
  const [operacion, setOperacion] = useState(props.operacion);

  // Estado para controlar validaciones
  const [errores, setErrores] = useState({});

  // Función para llenar campos cuando se edita o consulta
  const llenarCampos = (datos) => {
    if (!datos) return;

    console.log('Datos a llenar en modal cargo:', datos); // Para depuración

    // Cargo (índice 3 en el Java)
    if (txtCargo.current && datos[3]) {
      txtCargo.current.value = datos[3];
    }

    // Departamento (índice 2 en el Java)
    if (txtDepartamento.current && datos[2]) {
      txtDepartamento.current.value = datos[2];
    }

    // Fecha Inicio (índice 0 en el Java)
    if (txtFechaInicio.current && datos[0] && datos[0] !== 'DD/MM/AAAA') {
      // Convertir de DD/MM/AAAA a YYYY-MM-DD para input type="date"
      const fecha = datos[0].split('/');
      if (fecha.length === 3) {
        txtFechaInicio.current.value = `${fecha[2]}-${fecha[1]}-${fecha[0]}`;
      }
    } else {
      txtFechaInicio.current.value = '';
    }

    // Fecha Fin (índice 1 en el Java)
    if (txtFechaFin.current && datos[1] && datos[1] !== 'DD/MM/AAAA') {
      const fecha = datos[1].split('/');
      if (fecha.length === 3) {
        txtFechaFin.current.value = `${fecha[2]}-${fecha[1]}-${fecha[0]}`;
      }
    } else {
      txtFechaFin.current.value = '';
    }

    // Observación (índice 4 en el Java)
    if (txtObservacion.current && datos[4]) {
      txtObservacion.current.value = datos[4];
    }
  };

  // Efecto para cargar datos cuando se edita o consulta
  useEffect(() => {
    setOperacion(props.operacion);

    if (props.datos && (props.operacion === 2 || props.operacion === 4)) {
      // Llamar a llenarCampos cuando se reciben datos
      setTimeout(() => {
        llenarCampos(props.datos);
      }, 100); // Pequeño retraso para asegurar que los refs estén listos

      if (props.operacion === 4) {
        deshabilitarCampos();
      } else if (props.operacion === 2) {
        habilitarCampos();
      }
    }
  }, [props.datos, props.operacion]);

  const deshabilitarCampos = () => {
    const campos = [txtCargo, txtDepartamento, txtFechaInicio, txtFechaFin, txtObservacion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = true;
    });
  };

  const habilitarCampos = () => {
    const campos = [txtCargo, txtDepartamento, txtFechaInicio, txtFechaFin, txtObservacion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = false;
    });
  };

  const validarCampos = () => {
    const nuevosErrores = {};
    let valido = true;

    // Validar cargo
    if (!txtCargo.current?.value?.trim()) {
      nuevosErrores.cargo = "El cargo no debe estar en blanco";
      valido = false;
      txtCargo.current?.focus();
    }

    // Validar departamento
    if (!txtDepartamento.current?.value?.trim()) {
      nuevosErrores.departamento = "El departamento no debe estar en blanco";
      valido = false;
    }

    // Validar fecha de inicio
    if (!txtFechaInicio.current?.value) {
      nuevosErrores.fechaInicio = "La fecha de inicio es requerida";
      valido = false;
      if (valido) txtFechaInicio.current?.focus();
    } else {
      const fechaInicio = moment(txtFechaInicio.current.value);
      if (!fechaInicio.isValid()) {
        nuevosErrores.fechaInicio = "La fecha de inicio no es válida";
        valido = false;
      } else if (fechaInicio.isAfter(moment())) {
        nuevosErrores.fechaInicio = "La fecha de inicio no debe ser mayor a la fecha actual";
        valido = false;
      }
    }

    // Validar fecha de fin
    if (!txtFechaFin.current?.value) {
      nuevosErrores.fechaFin = "La fecha de fin es requerida";
      valido = false;
    } else {
      const fechaFin = moment(txtFechaFin.current.value);
      if (!fechaFin.isValid()) {
        nuevosErrores.fechaFin = "La fecha de fin no es válida";
        valido = false;
      } else if (fechaFin.isAfter(moment())) {
        nuevosErrores.fechaFin = "La fecha de fin no debe ser mayor a la fecha actual";
        valido = false;
      }
    }

    // Validar que fecha fin no sea menor a fecha inicio
    if (txtFechaInicio.current?.value && txtFechaFin.current?.value) {
      const fechaInicio = moment(txtFechaInicio.current.value);
      const fechaFin = moment(txtFechaFin.current.value);
      if (fechaFin.isBefore(fechaInicio)) {
        nuevosErrores.fechaFin = "La fecha de fin no puede ser menor a la fecha de inicio";
        valido = false;
      }
    }

    setErrores(nuevosErrores);
    return valido;
  };

  const aceptar = () => {
    if (operacion === 1 || operacion === 2) {
      if (!validarCampos()) {
        return;
      }
    }

    // Formatear fechas de YYYY-MM-DD a DD/MM/AAAA como en Java
    const fechaInicio = txtFechaInicio.current?.value;
    const fechaInicioFormateada = fechaInicio
      ? moment(fechaInicio).format('DD/MM/YYYY')
      : 'DD/MM/AAAA';

    const fechaFin = txtFechaFin.current?.value;
    const fechaFinFormateada = fechaFin
      ? moment(fechaFin).format('DD/MM/YYYY')
      : 'DD/MM/AAAA';

    // Construir objeto con los datos en el mismo orden que Java
    const datosCargo = {
      fechaini: fechaInicioFormateada,  // fecha inicio
      fechafin: fechaFinFormateada,  // fecha fin
      nomdep: txtDepartamento.current?.value?.toUpperCase(),    // departamento
      nomcar: txtCargo.current?.value?.toUpperCase(),    // cargo
      observacion: txtObservacion.current?.value?.toUpperCase() // observación
    }



console.log('Datos del cargo a enviar:', datosCargo);

// Devolver los datos al componente padre
if (props.onAceptar) {
  props.onAceptar(datosCargo);
}

props.onHide();
  };

const cancelar = () => {
  // Limpiar campos
  if (txtCargo.current) txtCargo.current.value = '';
  if (txtDepartamento.current) txtDepartamento.current.value = '';
  if (txtFechaInicio.current) txtFechaInicio.current.value = '';
  if (txtFechaFin.current) txtFechaFin.current.value = '';
  if (txtObservacion.current) txtObservacion.current.value = '';

  props.onHide();
};

console.log('Datos recibidos en cargo:', props.datos || 'No hay datos');

return (
  <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
    backdrop="static"
    keyboard={false}
    onShow={() => {
      setOperacion(props.operacion);

      if (props.operacion === 1) {
        // Limpiar campos para nuevo registro
        if (txtCargo.current) txtCargo.current.value = '';
        if (txtDepartamento.current) txtDepartamento.current.value = '';
        if (txtFechaInicio.current) txtFechaInicio.current.value = '';
        if (txtFechaFin.current) txtFechaFin.current.value = '';
        if (txtObservacion.current) txtObservacion.current.value = '';
        if (txtCargo.current) txtCargo.current.focus();
      } else if (props.datos) {
        // Para edición o consulta, llenar los campos
        setTimeout(() => {
          llenarCampos(props.datos);

          if (props.operacion === 4) {
            deshabilitarCampos();
          } else if (props.operacion === 2) {
            habilitarCampos();
          }
        }, 100);
      }
    }}
  >
    <Modal.Header className="header-azulGradiant">
      <h3>
        {operacion === 1 && "Incluir Cargo"}
        {operacion === 2 && "Editar Cargo"}
        {operacion === 4 && "Consultar Cargo"}
      </h3>
      <a type="button" onClick={cancelar} style={{ cursor: 'pointer' }}>
        salir <i className="fa fa-times"></i>
      </a>
    </Modal.Header>
    <Modal.Body>
      <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center">
        <legend className="float-none m-0 w-auto">Datos del Cargo</legend>

        {/* Mostrar errores de validación */}
        {Object.keys(errores).length > 0 && (
          <div className="alert alert-danger col-12" role="alert">
            {Object.values(errores).map((error, index) => (
              <div key={index}>• {error}</div>
            ))}
          </div>
        )}

        <div className="col-md-12 px-0 mx-auto row">
          {/* Cargo - Primer campo según el orden de Java */}
          <div className="input-group input-group-sm mb-3 col-md-12">
            <span className="input-group-text" style={{ width: '120px' }}>Cargo:</span>
            <input
              type="text"
              className="form-control"
              ref={txtCargo}
              disabled={operacion === 4 || operacion === 3 ? true : false}
              maxLength="100"
              onKeyDown={(e) => {
                if (e.key === 'Enter') txtDepartamento.current?.focus();
              }}
            />
          </div>

          {/* Departamento - Segundo campo */}
          <div className="input-group input-group-sm mb-3 col-md-12">
            <span className="input-group-text" style={{ width: '120px' }}>Departamento:</span>
            <input
              type="text"
              className="form-control"
              ref={txtDepartamento}
              disabled={operacion === 4 || operacion === 3 ? true : false}
              maxLength="100"
              onKeyDown={(e) => {
                if (e.key === 'Enter') txtFechaInicio.current?.focus();
              }}
            />
          </div>

          {/* Fecha Inicio - Tercer campo */}
          <div className="input-group input-group-sm mb-3 col-md-6">
            <span className="input-group-text" style={{ width: '120px' }}>Fecha Inicio:</span>
            <input
              type="date"
              className="form-control"
              ref={txtFechaInicio}
              disabled={operacion === 4 || operacion === 3 ? true : false}
              onKeyDown={(e) => {
                if (e.key === 'Enter') txtFechaFin.current?.focus();
              }}
            />
          </div>

          {/* Fecha Fin - Cuarto campo */}
          <div className="input-group input-group-sm mb-3 col-md-6">
            <span className="input-group-text" style={{ width: '120px' }}>Fecha Fin:</span>
            <input
              type="date"
              className="form-control"
              ref={txtFechaFin}
              disabled={operacion === 4 || operacion === 3 ? true : false}
              onKeyDown={(e) => {
                if (e.key === 'Enter') txtObservacion.current?.focus();
              }}
            />
          </div>

          {/* Observación - Quinto campo */}
          <div className="input-group input-group-sm mb-3 col-md-12">
            <span className="input-group-text" style={{ width: '120px' }}>Observación:</span>
            <textarea
              rows="3"
              className="form-control"
              ref={txtObservacion}
              disabled={operacion === 4 || operacion === 3 ? true : false}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) aceptar();
              }}
            />
          </div>
        </div>
      </fieldset>
    </Modal.Body>
    <Modal.Footer className="footer-azulGradiant">
      {(operacion === 1 || operacion === 2) && (
        <button
          type="button"
          className="btn btn-sm rounded-pill col-md-2 btn-success"
          onClick={aceptar}
        >
          Aceptar
        </button>
      )}
      <button
        type="button"
        onClick={cancelar}
        className="btn btn-sm rounded-pill col-md-2 btn-danger"
      >
        Cancelar
      </button>
    </Modal.Footer>
  </Modal>
);
};